import Vue from 'vue'
import Router from 'vue-router'
import store from '../store';

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Login = () => import('@/views/account/Login');

// My creditapps
const CreditAppPin = () => import('@/views/creditapps/CreditAppPin')
const Step1 = () => import('@/views/creditapps/Step1')
const Step2 = () => import('@/views/creditapps/Step2')
const Cobuyer = () => import('@/views/creditapps/Cobuyer')
const Privacy = () => import('@/views/creditapps/Privacy')
const Thanks = () => import('@/views/creditapps/Thanks')

// Short credit app
const ShortStep1 = () => import('@/views/creditapps/ShortStep1')
const ShortStep2 = () => import('@/views/creditapps/ShortStep2')


// quick-qualifys
const QuickQualify = () => import('@/views/quick-qualify/QuickQualify')
const QuickQualifyResult = () => import('@/views/quick-qualify/QuickQualifyResult')
const QuickQualifyIframe = () => import('@/views/quick-qualify/QuickQualifyIframe')

Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/404',
      name: 'CreditApps',
      component: DefaultContainer,
      children: [
        {
            path: 'login',
            name: 'Login',
            component: Login,
        },
        {
            path: 'creditapp/short/:clientId/:leadId/',
            name: 'ShortCreditAppPin',
            component: CreditAppPin,
            beforeEnter: (to, from, next) => {
                const { clientId } = to.params;
                Promise.all([
                    store.dispatch('client/getClient', { clientId }),
                ]).then(() => next());
            },
        },
        {
            path: 'creditapp/short/:clientId/:leadId/1',
            name: 'ShortStep1',
            component: ShortStep1,
            beforeEnter: (to, from, next) => {
                const path = to.path.slice(0, -2);
                const lead = store.getters['lead/currentLead'];
                if(lead && lead.urlhash) {
                    next();
                } else {
                    next({ path });
                }
            },
        },
        {
            path: 'creditapp/short/:clientId/:leadId/2',
            name: 'ShortStep2',
            component: ShortStep2,
            beforeEnter: (to, from, next) => {
                const path = to.path.slice(0, -2);
                const lead = store.getters['lead/currentLead'];
                if(lead && lead.urlhash) {
                    next();
                } else {
                    next({ path });
                }
            },
        },
        {
            path: 'creditapp/:clientId',
            name: 'CreditAppStart',
            component: Step1,
            beforeEnter: (to, from, next) => {
                const { clientId } = to.params;
                Promise.all([
                    store.dispatch('client/getClient', { clientId }),
                ]).then(() => next());
            },
        },
        {
            path: 'creditapp/:clientId/:leadId',
            name: 'CreditAppPin',
            component: CreditAppPin,
            beforeEnter: (to, from, next) => {
                const { clientId } = to.params;
                Promise.all([
                    store.dispatch('client/getClient', { clientId }),
                ]).then(() => next());
            },
        },
        {
            path: 'creditapp/:clientId/:leadId/:creditApplicationId',
            name: 'CobuyerCreditAppPin',
            component: CreditAppPin,
            beforeEnter: (to, from, next) => {
                const { clientId, creditApplicationId } = to.params;
                const path = to.path.slice(0, -2);
                if (creditApplicationId.length < 12) {
                    next({ path });
                }
                Promise.all([
                    store.dispatch('client/getClient', { clientId }),
                ]).then(() => next());
            },
        },
        {
          path: 'creditapp/:clientId/:leadId/1',
            name: 'Step1',
            component: Step1,
            beforeEnter: (to, from, next) => {
                const path = to.path.slice(0, -2);
                const id = store.getters['creditapps/currentCreditApp'].id;
                const authToken = store.getters['creditapps/currentCreditApp'].lead;
                Promise.all([
                    store.dispatch('creditapps/getCreditApp', { id, authToken }),
                ]).then(() => next()).catch(() => {
                    const lead = store.getters['lead/currentLead'];
                    if(lead && lead.urlhash) {
                        next();
                    } else {
                        next({ path });
                    }
                });
            },
        },
        {
          path: 'creditapp/:clientId/:leadId/:creditApplicationId/1',
            name: 'CobuyerStep1',
            component: Step1,
            beforeEnter: (to, from, next) => {
                const path = to.path.slice(0, -2);
                const id = store.getters['creditapps/currentCreditApp'].id;
                const authToken = store.getters['creditapps/currentCreditApp'].lead;
                Promise.all([
                    store.dispatch('creditapps/getCreditApp', { id, authToken }),
                ]).then(() => next()).catch(() => {
                    const lead = store.getters['lead/currentLead'];
                    if(lead && lead.urlhash) {
                        next();
                    } else {
                        next({ path });
                    }
                });
            },
        },
        {
            path: 'creditapp/:clientId/:leadId/2',
            name: 'Step2',
            component: Step2,
            beforeEnter: async (to, from, next) => {
                const path = to.path.slice(0, -2);
                const id = store.getters['creditapps/currentCreditApp'].id;
                const authToken = store.getters['creditapps/currentCreditApp'].lead;
                Promise.all([
                    store.dispatch('creditapps/getCreditApp', { id, authToken }),
                ]).then(() => next()).catch(() => next({ path }));
            },
        },
        {
            path: 'creditapp/:clientId/:leadId/:creditApplicationId/2',
            name: 'CobuyerStep2',
            component: Step2,
            beforeEnter: async (to, from, next) => {
                const path = to.path.slice(0, -2);
                const id = store.getters['creditapps/currentCreditApp'].id;
                const authToken = store.getters['creditapps/currentCreditApp'].lead;
                Promise.all([
                    store.dispatch('creditapps/getCreditApp', { id, authToken }),
                ]).then(() => next()).catch(() => next({ path }));
            },
        },
        {
          path: 'creditapp/:clientId/:leadId/cobuyer',
            name: 'Cobuyer',
            component: Cobuyer,
            beforeEnter: async (to, from, next) => {
                const path = to.path.slice(0, -2);
                const id = store.getters['creditapps/currentCreditApp'].id;
                const authToken = store.getters['creditapps/currentCreditApp'].lead;
                Promise.all([
                    store.dispatch('creditapps/getCreditApp', { id, authToken }),
                ]).then(() => next()).catch(() => next({ path }));
            },
        },
        {
          path: 'creditapp/:clientId/:leadId/privacy',
            name: 'Privacy',
            component: Privacy,
            beforeEnter: async (to, from, next) => {
                const path = to.path.slice(0, -2);
                const id = store.getters['creditapps/currentCreditApp'].id;
                const authToken = store.getters['creditapps/currentCreditApp'].lead;
                Promise.all([
                    store.dispatch('creditapps/getCreditApp', { id, authToken }),
                ]).then(() => next()).catch(() => next({ path }));
            },
        },
        {
          path: 'creditapp/:clientId/:leadId/:creditApplicationId/privacy',
            name: 'CobuyerPrivacy',
            component: Privacy,
            beforeEnter: async (to, from, next) => {
                const path = to.path.slice(0, -2);
                const id = store.getters['creditapps/currentCreditApp'].id;
                const authToken = store.getters['creditapps/currentCreditApp'].lead;
                Promise.all([
                    store.dispatch('creditapps/getCreditApp', { id, authToken }),
                ]).then(() => next()).catch(() => next({ path }));
            },
        },
        {
            path: 'creditapp/short/:clientId/:leadId/thanks',
            name: 'ShortThanks',
            component: Thanks,
            beforeEnter: (to, from, next) => {
                Promise.all([
                    store.dispatch('lead/clearLead'),
                ]).then(() => next());
            },
        },
        {
            path: 'creditapp/:clientId/:leadId/thanks',
            name: 'Thanks',
            component: Thanks,
            beforeEnter: (to, from, next) => {
                Promise.all([
                    store.dispatch('lead/clearLead'),
                ]).then(() => next());
            },
        },
        {
            path: 'creditapp/:clientId/:leadId/:creditApplicationId/thanks',
            name: 'CobuyerThanks',
            component: Thanks,
            beforeEnter: (to, from, next) => {
                Promise.all([
                    store.dispatch('lead/clearLead'),
                ]).then(() => next());
            },
        },
        {
          path: 'quick-qualify/:clientId',
            name: 'QuickQualify',
            component: QuickQualify,
            beforeEnter: (to, from, next) => {
                const { clientId } = to.params;
                Promise.all([
                    store.dispatch('client/getClient', { clientId }),
                ]).then(() => next());
            },
        },
        {
          path: 'quick-qualify/result/:client/:guid',
            name: 'QuickQualifyResult',
            component: QuickQualifyResult,

            beforeEnter: (to, from, next) => {
                const { guid, client } = to.params;
                Promise.all([
                    store.dispatch('client/getClient', { clientId: client }),
                    store.dispatch('quickQualify/getQuickQualification', { guid, client }),
                ])
                    .then(() => next());
                    //.catch(() => next('/'));
            },

        },
        {
          path: 'quick-qualify/frame/:client/:guid',
            name: 'QuickQualifyIframe',
            component: QuickQualifyIframe,

            beforeEnter: (to, from, next) => {
                const { guid, client } = to.params;
                Promise.all([
                    store.dispatch('quickQualify/getQuickQualification', { guid, client }),
                ])
                    .then(() => next());
                    //.catch(() => next('/'));
            },

        },
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
      ]
    },

  ]
})

// Set up private authenticated routes
router.beforeEach((to, from, next) => {
    // Redirect to 404 page
    if (!to.matched.length) {
        next('/404');
    }

    // If auth is required verify auth or redirect to login
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // If the user is logged in
        if (store.getters['auth/isAuthenticated']) {
            store.dispatch('auth/fetchUser').then(() => {
                next();
            });

        } else {
            // Send to login page with redirect parameter
            next({
                path: '/login',
                query: {
                    // URL to go to after successful login
                    redirect: to.fullPath,
                },
            });
        }
        // Auth is not required for route
    } else {
        next();
    }
});

export default router;
